// ----------------------------------------------------------------------------
// Разные мелкие общие функции для ЛК и авторизации/регистрации
// ----------------------------------------------------------------------------



import {authElements} from "./auth-account-elements.js";
import {modalWindowCloseManage, modalWindowCreateFromTemplate} from "../modal/modal-window-manager.js";
import createElement from "../create/createElement.js";

/**
 * Удаляет элементы со страницы по указанному CSS-селектору.
 *
 * @param {string} selector - CSS-селектор DOM-элемента(ов) для удаления.
 * @returns {void}
 */
export function removeElements(selector) {
    if (!selector) return;

    const elements = document.querySelectorAll(selector);
    elements.forEach(el => el.remove());
}



/**
 * Осуществляет переход на /myaccount/ (или перезагрузку если пользователь уже на /myaccount/)
 * @returns {void}
 */
export function ttReload() {
    setTimeout(function () {
        window.location.href = '/myaccount/';
    }, 2000);
}


/**
 * Выводит в шапке сайта информацию о залогиненном пользователе
 * @param {Object} data - Объект с данными ответа от сервера.
 * @param {string} data.user_name - имя пользователя
 */
export function setHeaderLoggedInState(data) {
    authElements.headerTTUserNames.forEach(el => el.textContent = data.user_name);
    authElements.headerTTUsers.forEach(el => el.style.display = '');
    authElements.headerTTAuthRegistrations.forEach(el => el.style.display = 'none');

    window.ttUserIsLoggedIn = true;
}

/**
 * Выводит в консоль ошибку и редиректит на /myaccount/
 * @param {Error|string} error - Текст ошибки от сервера или объект ошибки.
 * @returns {void}
 */

export function loginWithErrors(error) {
    const modalContent = `
                <h2 class="modal-window__title">Ошибка авторизации</h2>
                <p class="modal-window__p">${error}</p>
        `;

    const redirectButton = createElement('a', {href: '/myaccount/', class: ['button', 'button--s', 'button--black']}, 'Перейти на страницу авторизации');
    const closeButton = createElement('button', {type: 'button', class: ['button', 'button--s', 'button--black']}, 'Закрыть окно');
    const modalFooter = createElement('div', {class: 'modal-window__2btns'});
    modalFooter.append(redirectButton);
    modalFooter.append(closeButton);

    // сделали клон модалки из template
    const modalFragment = modalWindowCreateFromTemplate('modal-template', modalContent, modalFooter, true);

    // показали окно
    if (modalFragment) {
        const modalWrapper = modalFragment.querySelector(`[data-modal-window="wrapper"]`);
        if (modalWrapper) {
            modalWindowCloseManage(closeButton, modalWrapper);
            modalWrapper.style.display = 'flex';
        }
        document.body.append(modalFragment);
    }
}